import { render, staticRenderFns } from "./agreementView.vue?vue&type=template&id=6f25e20d&"
import script from "./agreementView.vue?vue&type=script&lang=js&"
export * from "./agreementView.vue?vue&type=script&lang=js&"
import style0 from "./agreementView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports